
(function () {
  function polishGoldenHomeFinal() {
    document.querySelectorAll('#goldenHomeTrendingTabs .ghProductPrice').forEach(function (wrap) {
      var meta = wrap.parentElement ? wrap.parentElement.querySelector('.ghProductMeta') : null;
      var main = wrap.querySelector('.ghMainPrice');
      var amount = wrap.querySelector('.ghMainPrice .ghPriceAmount');
      var currency = wrap.querySelector('.ghMainPrice .ghPriceCurrency');
      var compare = wrap.querySelector('.ghComparePrice');

      wrap.style.minHeight = window.innerWidth <= 749 ? '88px' : '94px';
      wrap.style.overflow = 'visible';

      if (meta) {
        meta.style.minHeight = window.innerWidth <= 749 ? '24px' : '24px';
        meta.style.marginBottom = '4px';
        meta.style.overflow = 'visible';
      }

      if (main) {
        main.style.background = 'transparent';
        main.style.display = 'grid';
        main.style.gridTemplateColumns = 'auto minmax(0, 1fr)';
        main.style.alignItems = 'center';
        main.style.overflow = 'visible';
      }

      if (currency) {
        currency.style.background = '#000000';
        currency.style.color = '#ffffff';
      }

      if (amount) {
        amount.style.color = '#d60000';
        amount.style.textAlign = 'right';
        amount.style.justifySelf = 'end';
        amount.style.background = 'transparent';
      }

      if (compare && !compare.classList.contains('isEmpty')) {
        compare.style.justifyContent = 'flex-end';
        compare.style.textAlign = 'right';
        compare.style.overflow = 'visible';
        compare.querySelectorAll('.ghPriceCurrency, .ghPriceAmount').forEach(function (el) {
          el.style.color = '#666666';
          el.style.textDecoration = 'line-through';
          el.style.textAlign = 'right';
        });
      }
    });

    document.querySelectorAll('.rating, .rating-star, .stars, .star-rating, .jdgm-prev-badge__stars, .spr-starrating, .loox-rating, .yotpo-stars').forEach(function (stars) {
      stars.style.overflow = 'visible';
      stars.style.minHeight = '30px';
      stars.style.height = 'auto';
      stars.style.lineHeight = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polishGoldenHomeFinal);
  } else {
    polishGoldenHomeFinal();
  }

  window.addEventListener('resize', polishGoldenHomeFinal);
  document.addEventListener('shopify:section:load', polishGoldenHomeFinal);
})();
